export default "__VITE_ASSET__Bp$C7VUW__"